import AgentProfile from 'models/agent_profile';
import createConverter from './lib/create_converter';

export default createConverter(AgentProfile);
